// removed by extract-text-webpack-plugin
module.exports = {"large-button":"large-button--34dL1","text":"text--1VhGZ","arrow":"arrow--2mvG_"};


//////////////////
// WEBPACK FOOTER
// ./client/components/large-button/large-button.scss
// module id = 482
// module chunks = 0